import "isomorphic-fetch";

process.env.NODE_TLS_REJECT_UNAUTHORIZED = "0"; // todo: remove this in favour of adding cert as insecure

export const hostserver = () => {
    if (process.env.HOSTSERVER) return process.env.HOSTSERVER;

    //If no HOSTSERVER is explicitly set, then use the current host
    return window.location.origin; //https://server.net
};

const getHeaders = () => {
    const headers: {[key: string]: string} = {};

    headers["Content-Type"] = "application/json; charset=utf-8";
    headers["Access-Control-Request-Headers"] = "*";
    headers["Access-Control-Allow-Origin"] = "*";

    const headerDict = {
        "Content-Type": "application/json; charset=utf-8",
        "Access-Control-Request-Headers": "*",
        "Access-Control-Allow-Origin": "*",
    };

    return headerDict;
};

export const get = (url: string) => {
    return fetch(hostserver() + url, {
        headers: getHeaders(),
        method: "GET",
    });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const post = (url: string, data: any) => {
    //debug(`Api: POST ${url} `);
    return fetch(hostserver() + url, {
        headers: getHeaders(),
        method: "POST",
        body: JSON.stringify(data),
    });
};

export const deleteRequest = (url: string) => {
    //debug(`Api: DELETE ${url}`);
    return fetch(hostserver() + url, {
        headers: getHeaders(),
        method: "DELETE",
        credentials: "same-origin",
    });
};
